import { initCaptalize } from "../../utils";

export class NotFoundException extends Error {
  protected _code: string;

  constructor(field) {
    super(`${initCaptalize(field)} not found.`);

    this.name = "NotFoundException";
    this._code = "notFound";
  }
}
